export class Lazy<T> {
    private val: T | undefined;

    public get value(): T {
        return this.val ?? (this.val = this.factory());
    }

    constructor(private factory: () => T) {}
}
